import List, { ListOptions, ListComponent } from './Classes/List';

// export default (options: ListOptions, filterData = {}):ListComponent => {
export default (options: ListOptions):ListComponent => {
  return List(options, {
    query: '',
    'states': [],
    'date_start': '',
    'date_end': '',
    location: '',
    'postal-code': '',
    'target_group': [],
    'seminar_type': [],
    'post_tag': [],
  })
};
